import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-chart-wrapper',
    templateUrl: './chart-wrapper.component.html',
    styleUrls: ['./chart-wrapper.component.scss'],
    standalone: false
})
export class ChartWrapperComponent {
  @Input() chartClass: string = '';

  private parentEl: any = '';
  public width = '100%';

  constructor() {
    setTimeout(() => {
      this.parentEl = document.getElementById('123');
      this.width = this.parentEl?.offsetWidth;
    }, 500);
  }
}
